import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AccessibilityTabContent } from '@skillz/accessibility';
import pathRouts from "../../../../shared/enums/pathRoute";
import { login } from "../../../../shared/store/redux/auth-actions";
import HeaderLogout from "../../headerLogout/HeaderLogout";
import PrimaryBtn from "../../../../shared/components/ui/buttons/PrimaryBtn";
import bgPrimaryBtn from "../../../../assests/notAuth/bgPrimaryBtn.png";
import InfoPartOne from "../../pages/home/sections/infoPartOne/InfoPartOne";
import NotAuthSections from "../../pages/home/NotAuthSections";
import classes from "./Home.module.css";
import ScrollLTR from "../../../../shared/components/ui/scrollLTR/ScrollLTR";
import { deviceTypes } from "../../../../shared/enums/deviceTypes";

const NotAuthHome = () => {

    const isAuth = useSelector((state) => state.auth.isAuth);
    const texts = useSelector((state) => state.translate.texts);
    const deviceType = useSelector((state) => state.responsive.deviceType);
    const dispatch = useDispatch();

    const loginBtn = () => {
        dispatch(login());
    };

    return (
        <AccessibilityTabContent id={pathRouts.HOME} hidden={!window.location.pathname.includes(pathRouts.HOME)}>
            <ScrollLTR height="100dvh" dropClass={classes.PageScroll}>
                {deviceType !== deviceTypes.mobile && <HeaderLogout />}

                <div className={classes.HomeWrapper}>
                    <InfoPartOne />
                    <NotAuthSections />

                    {!isAuth &&
                        <div className={classes.PrimaryMobileBtn}>
                            <PrimaryBtn onClick={loginBtn} background={`transparent url(${bgPrimaryBtn})`} color="white" dropClass={classes.LoginBtnDrop}>
                                {texts.topBannerBtnText}
                            </PrimaryBtn>
                        </div>
                    }
                </div>
            </ScrollLTR>
        </AccessibilityTabContent>
    );
};

export default NotAuthHome;